import { getAuthHeaders } from '../utils/authHeaders';
import { createFormPdf, PDF_COLORS, yesNoColor } from '../utils/formPdf';

const API_URL = 'https://app.pvslimited.co.uk/api';

const sendCustomerComplaintEmail = async (formData) => {
  const blob = await createFormPdf({
    title: 'CUSTOMER COMPLAINT & APPEAL FORM',
    ref: 'Ref: PVS-CCF-001 | Version: 1.0',
    subtitle: 'FOR INTERNAL USE ONLY - NOT FOR DISTRIBUTION OUTSIDE PVS LIMITED WITHOUT AUTHORISATION',
    subtitleColor: PDF_COLORS.amber,
  }, (pdf) => {
    pdf.section('GENERAL INFORMATION');
    pdf.field('Date Raised', formData.dateRaised);
    pdf.field('Raised By (Name/Role)', formData.raisedBy);
    pdf.field('Client / Customer Name', formData.clientName);

    pdf.section('SECTION 1: COMPLAINT / APPEAL DETAILS');
    pdf.longText('Description of Complaint', formData.description);
    pdf.field('Serial Number', formData.serialNumber);
    pdf.field('Vessel Owner', formData.vesselOwner);
    pdf.field('Water Capacity', formData.waterCapacity);
    pdf.field('Pre Inspection Date', formData.preInspectionDate);
    pdf.field('Pre Inspection Completed By', formData.preInspectionBy);
    pdf.field('Date Painted', formData.datePainted);
    pdf.field('Paint QC Completed By', formData.paintedBy);
    pdf.field('Inspection Date', formData.inspectionDate);
    pdf.field('Inspection Completed By', formData.inspectionBy);
    pdf.field('Quality Control Date', formData.qualityControlDate);
    pdf.field('QC Completed By', formData.qualityControlBy);
    pdf.field('Date Dispatched', formData.dateDispatched);
    pdf.field('PVS Inspector / Operator Name', formData.pvsInspectorName);

    pdf.section('SECTION 2: CLIENT ESCALATION');
    pdf.check('Requires formal escalation to the client', formData.requiresEscalation);
    pdf.field('Date Escalated', formData.dateEscalated);
    pdf.field('Client Representative Contacted', formData.clientRepresentative);
    pdf.field('Method of Contact', formData.contactMethod);

    pdf.section('SECTION 3: EXTENT AND IMPACT ASSESSMENT');
    pdf.check('Affects other assets/vessels in the current batch', formData.affectsOtherVessels);
    pdf.check('Previous inspections or services potentially compromised', formData.previousCompromised);
    pdf.field('Risk Level', formData.riskLevel, yesNoColor(formData.riskLevel));
    pdf.check('Safety Impact', formData.safetyImpact);
    if (formData.safetyImpact === 'yes') {
      pdf.longText('Safety Impact Description', formData.safetyImpactDetails);
    }
    pdf.longText('Impact Summary', formData.impactSummary);

    pdf.section('SECTION 4: ROOT CAUSE INVESTIGATION');
    pdf.longText('Root Cause Identified', formData.rootCause);

    pdf.section('SECTION 5: CORRECTIVE AND PREVENTATIVE ACTION');
    pdf.longText('Immediate Corrective Action Taken', formData.correctiveAction);
    pdf.longText('Preventative Action Implemented', formData.preventativeAction);

    pdf.section('SECTION 6: CLOSE-OUT & SIGNATURES');
    pdf.field('PVS Quality/Operations Manager Sign-off', formData.qualityManagerSignoff);
    pdf.field('Sign-off Date', formData.qualityManagerDate);
    pdf.field('Client Representative Sign-off', formData.clientSignoff);
    pdf.field('Client Sign-off Date', formData.clientSignoffDate);
  });

  const payload = new FormData();
  const filename = `Customer_Complaint_${(formData.clientName || 'form').replace(/[^a-z0-9]+/gi, '_')}_${Date.now()}.pdf`;
  payload.append('file', blob, filename);
  payload.append('dateRaised', formData.dateRaised || '');
  payload.append('raisedBy', formData.raisedBy || '');
  payload.append('clientName', formData.clientName || '');
  payload.append('serialNumber', formData.serialNumber || '');
  payload.append('vesselOwner', formData.vesselOwner || '');
  payload.append('waterCapacity', formData.waterCapacity || '');
  payload.append('preInspectionDate', formData.preInspectionDate || '');
  payload.append('preInspectionBy', formData.preInspectionBy || '');
  payload.append('datePainted', formData.datePainted || '');
  payload.append('paintedBy', formData.paintedBy || '');
  payload.append('inspectionDate', formData.inspectionDate || '');
  payload.append('inspectionBy', formData.inspectionBy || '');
  payload.append('qualityControlDate', formData.qualityControlDate || '');
  payload.append('qualityControlBy', formData.qualityControlBy || '');
  payload.append('dateDispatched', formData.dateDispatched || '');
  payload.append('requiresEscalation', formData.requiresEscalation || 'no');
  payload.append('riskLevel', formData.riskLevel || '');
  payload.append('safetyImpact', formData.safetyImpact || 'no');
  payload.append('safetyImpactDetails', formData.safetyImpactDetails || '');
  payload.append('formType', 'customer-complaint');

  const response = await fetch(`${API_URL}/send-customer-complaint-email`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: payload
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
  }

  return response.json();
};

export default sendCustomerComplaintEmail;
